"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AttachmentIcon = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgIcon = require("../SvgIcon");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
} /**
  * This file was generated by the build:icons script
  * See Notion for details on how to add icons
  */
const AttachmentIcon = props => /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, _extends({}, props, {
  viewBox: "0 0 24 24"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.14 5.144a2.556 2.556 0 0 0-3.52-.16l-8.527 7.41a3.866 3.866 0 1 0 5.071 5.836l8.553-7.433a.85.85 0 1 1 1.115 1.284l-8.553 7.432a5.566 5.566 0 0 1-7.301-8.403l8.526-7.408a4.256 4.256 0 0 1 5.583 6.424l-7.733 6.72A2.946 2.946 0 0 1 7.489 12.4l3.942-3.426a.85.85 0 0 1 1.116 1.284l-3.943 3.425a1.246 1.246 0 0 0 1.635 1.881l7.733-6.72a2.556 2.556 0 0 0 .168-3.699Z"
}));
exports.AttachmentIcon = AttachmentIcon;